export const months = [{
    id: 1,
    name: 'Enero'
  }, {
    id: 2,
    name: 'Febrero'
  }, {
    id: 3,
    name: 'Marzo'
  }, {
    id: 4,
    name: 'Abril'
  }, {
    id: 5,
    name: 'Mayo'
  }, {
    id: 6,
    name: 'Junio'
  }, {
    id: 7,
    name: 'Julio'
  }, {
    id: 8,
    name: 'Agosto'
  }, {
    id: 9,
    name: 'Septiembre'
  }, {
    id: 10,
    name: 'Octubre'
  }, {
    id: 11,
    name: 'Noviembre'
  }, {
    id: 12,
    name: 'Diciembre'
  }];

  function* getYears(start, end){
      let i = start;    

      while(i < end){
          yield i++;
      }
  } 
  const initDate = new Date(2021,1,1,0,0,0,0).getFullYear();
  const endDate = new Date().getFullYear();
  export const years = [...getYears(initDate, endDate + 1 )]

  //export const months = [...getYears(1, 12 )]

  export const days = [...getYears(1, 31)]